'use strict';
(function($){
	var $component = $('.picklist');

	if($component.length > 0){
		var $picklistInput = $component.find('.picklist-input');
		var $availableData = $component.find('.available-data');
		var $allowedData = $component.find('.allowed-data');

		$availableData.on('click', 'div[code]', function(){
			$(this).clone().prependTo($allowedData);
			$(this).remove();
			$allowedData.scrollTop(0);
			$allowedData.find('.all').hide();
			updatePicklistInput();
		});

		$allowedData.on('click', 'div[code]', function(){
			$(this).clone().prependTo($availableData);
			$(this).remove();
			$availableData.scrollTop(0);
			updatePicklistInput();
			if($allowedData.find('div[code]').length < 1){
				$allowedData.find('.all').show();
			}
		});

		if($picklistInput.length > 0 && $picklistInput.val() != ''){
			try{
				var allowedData = JSON.parse($picklistInput.val());
			}catch(err){
				console.error(err);
				return;
			}
			if(Array.isArray(allowedData)){
				allowedData.forEach(function(allowedCountry){
					$availableData.find('[code="' + allowedCountry + '"]').trigger('click');
				});
			}
		}

		var $searchInput = $component.find('.picklist-search input');

		$searchInput.keyup(function(ev){
			var searchText = $(this).val();
			var $data = $availableData.find('[code]');
			$data.each(function(){
				if( $(this).text().toLowerCase().indexOf(searchText) > -1 || searchText == '') {
					$(this).show();
				}else{
					$(this).hide();
				}
			});
		})
	}

	function updatePicklistInput(){
		var $items = $allowedData.find('div[code]');
		var data = [];
		$items.each(function(){
			data.push($(this).attr('code'));
		});
		$picklistInput.val(JSON.stringify(data));
	}

}(jQuery));
